interface ValidationErrorProps {
  error?: string | string[];
  className?: string;
}

export const ValidationError = ({ error, className = '' }: ValidationErrorProps) => {
  if (!error) return null;

  const errors = Array.isArray(error) ? error : [error];

  return (
    <div className={`text-sm text-red-600 mt-1 ${className}`} role="alert">
      {errors.map((err, index) => (
        <div key={index} className="flex items-start space-x-1">
          <span className="text-red-500 mt-0.5">•</span>
          <span>{err}</span>
        </div>
      ))}
    </div>
  );
};